import type { Faq as FaqData } from '@mathflat/domain/Notice'

import { EMPTY_NUMBER_ID } from '@/constant/common'

import { DTO } from '../DTO'

export class Faq extends DTO implements FaqData {
  id = EMPTY_NUMBER_ID
  type: FaqData['type'] = 'ETC'
  content = ''
  question = ''
  priority = EMPTY_NUMBER_ID

  constructor(data?: FaqData) {
    super()
    if (data) this.update<Faq>(data)
  }
}
